export const languages = [
  {
    logo: <i className="fa-brands fa-java fa-2x"></i>,
    name: "Java/Spigot",
    status: "Fluent",
  },
  {
    logo: <i className="fa-brands fa-html5 fa-3x"></i>,
    name: "HTML5",
    status: "Fluent",
  },
  {
    logo: <i className="fa-brands fa-ubuntu fa-3x"></i>,
    name: "Linux",
    status: "Semi-Fluent",
  },
  {
    logo: <i className="fa-brands fa-react fa-3x"></i>,
    name: "React",
    status: "Semi-Fluent",
  },
  {
    logo: <i className="fa-brands fa-css3-alt fa-3x"></i>,
    name: "CSS",
    status: "Still learning",
  },
  {
    logo: <i className="fa-brands fa-js fa-3x"></i>,
    name: "JavaScript",
    status: "Still learning",
  },
];
